"use client";

import * as React from "react";

// Clean Switch component without external dependencies
function Switch({
  className = "",
  checked = false,
  onCheckedChange,
  disabled = false,
  ...props
}: {
  className?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  [key: string]: any;
}) {
  const [isChecked, setIsChecked] = React.useState(checked);

  React.useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleClick = () => {
    if (disabled) return;
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    onCheckedChange?.(newChecked);
  };

  const switchClasses = `
    peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent 
    transition-all outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 
    disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer relative
    ${isChecked 
      ? 'bg-primary focus-visible:border-ring' 
      : 'bg-switch-background focus-visible:border-ring dark:bg-input/80'
    }
    ${className}
  `;

  const thumbClasses = `
    pointer-events-none block size-4 rounded-full ring-0 transition-transform
    ${isChecked 
      ? 'translate-x-[calc(100%-2px)] bg-card dark:bg-primary-foreground' 
      : 'translate-x-0 bg-card dark:bg-card-foreground'
    }
  `;

  return (
    <button
      role="switch"
      aria-checked={isChecked}
      className={switchClasses}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      <div className={thumbClasses} />
    </button>
  );
}

export { Switch };